import api, { handleAPIErrors } from 'shared/api'

const FETCH_REQUEST = 'governmentExecutives/FETCH_REQUEST';
const FETCH_SUCCESS = 'governmentExecutives/FETCH_SUCCESS';
const FETCH_GOVERNMENT_SUCCESS = 'governmentExecutives/FETCH_GOVERNMENT_SUCCESS';
const FETCH_FAILURE = 'governmentExecutives/FETCH_FAILURE';

const initialState = {
  governments: [],
  loadedGovernments: [],
  loadedIds: [],
  loaded: false,
  loading: false,
  errors: []
};

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchGovernmentSuccess(payload) {
  return {
    type: FETCH_GOVERNMENT_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadGovernment(id, options = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const loadedIds = state.governments.loadedIds ? state.governments.loadedIds.slice() : [];
    if (!loadedIds.includes(id)) {
      loadedIds.push(id)
    }

    dispatch(fetchRequest({ loadedIds }));

    return api(`api/v1/governments/${id}`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchGovernmentSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      });
  }
}

export function loadGovernments(options = {}) {
  return (dispatch) => {
    dispatch(fetchRequest());

    return api('api/v1/governments', options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      });
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedIds: action.loadedIds || state.loadedIds,
      });
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        governments: [...payload]
      });
    case FETCH_GOVERNMENT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        errors: [],
        loadedGovernments: [
          ...state.loadedGovernments,
          payload
        ]
      });
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      });
    default:
      return state
  }
}

